"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _utils = require("../../../../utils");
var _hooks = require("../../../../hooks");
var _ui = require("../../../ui");
var _transactionInfo = require("../withdraw/transaction-info");
var _TwoFactorForm = require("../withdraw/TwoFactorForm");
var _BalanceName = require("../withdraw/BalanceName");
var _SubmitButton = require("./SubmitButton");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ModalBody = (0, _styledComponents.default)(_ui.ModalBody)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 20px 20px 30px;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 0 10px 40px;\n  "]))));
var TotalAmount = (0, _styledComponents.default)(_transactionInfo.TransactionInfoTotalAmount)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: 20px 0;\n"])));
var StyledAlert = (0, _styledComponents.default)(_ui.Alert)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top: 28px;\n  margin-bottom: 20px;\n"])));
var ConfirmModal = function ConfirmModal(_ref) {
  var _props$price, _props$price2, _props$price3;
  var withdraw2faEnabled = _ref.withdraw2faEnabled,
    balanceName = _ref.balanceName,
    children = _ref.children,
    ToComponent = _ref.toComponent;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon', 'libAuth']),
    t = _useTranslation.t;
  var props = (0, _hooks.useExchangeContext)();
  var SubmitBtn = (0, _styledComponents.default)(function (params) {
    return /*#__PURE__*/_react.default.createElement(_SubmitButton.SubmitButton, _extends({
      afterTimeoutClick: props.getExchangeInfo,
      loading: props.modalSubmitLoading || props.exchangeInfo.loading,
      timeout: props.infoTimeout
    }, params), props.minOrMaxChanged ? t('limitsChanged') : !props.isEnoughBalance ? t('notEnoughBalance') : props.infoTimeout && !props.exchangeInfo.loading ? t('confirm&send') : t('updatePrice'));
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    margin-bottom: 20px;\n  "])));
  return /*#__PURE__*/_react.default.createElement(_ui.Modal, {
    isOpen: props.modalOpen,
    toggle: props.toggleModal
  }, /*#__PURE__*/_react.default.createElement(_ui.ModalHeader, {
    toggle: props.toggleModal
  }, t('sendingConfirmation')), /*#__PURE__*/_react.default.createElement(ModalBody, null, /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoItem, {
    title: t('from')
  }, /*#__PURE__*/_react.default.createElement(_BalanceName.BalanceName, {
    ticker: props.ticker,
    value: balanceName
  })), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoItem, {
    title: t('to')
  }, ToComponent ? /*#__PURE__*/_react.default.createElement(ToComponent, null) : /*#__PURE__*/_react.default.createElement("span", {
    className: "text-truncate"
  }, props.address)), !props.isFiat && /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoItem, {
    title: t('network')
  }, /*#__PURE__*/_react.default.createElement("span", null, t('blockchains.' + props.blockchain), " ", t('network'))), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoItem, {
    title: t('exchange') + ':'
  }, /*#__PURE__*/_react.default.createElement(_ui.H6, {
    className: "mb-0"
  }, props.ticker, " to ", props.toTicker)), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('amountToSend') + ':',
    ticker: props.toTicker
    // fiatTicker={props.fiatTicker}
    ,
    amount: props.toAmount
    // fiatTickerAmount={props.fiatTickerToAmount}
  }), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('amountToWithdraw') + ':',
    ticker: props.ticker
    // fiatTicker={props.fiatTicker}
    ,
    amount: props.amount
    // fiatTickerAmount={props.fiatTickerAmount}
  }), props.maxLiquidity && /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('maxLiquidity') + ':',
    ticker: props.ticker,
    amount: props.maxLiquidity
  }), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('exchangeRate') + ':',
    ticker: (_props$price = props.price) === null || _props$price === void 0 ? void 0 : _props$price.pair[0],
    fiatTicker: (_props$price2 = props.price) === null || _props$price2 === void 0 ? void 0 : _props$price2.pair[1],
    amount: '1',
    fiatTickerAmount: (_props$price3 = props.price) === null || _props$price3 === void 0 ? void 0 : _props$price3.value
  }), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('fee') + ':',
    ticker: props.toTicker
    // fiatTicker={props.fiatTicker}
    ,
    amount: props.fee
    // fiatTickerAmount={props.fiatTickerFee}
  }), /*#__PURE__*/_react.default.createElement(TotalAmount, {
    ticker: props.toTicker
    // convertedTicker={props.fiatTicker}
    ,
    amount: props.total
    // convertedAmount={props.fiatTickerTotal}
  }), withdraw2faEnabled ? /*#__PURE__*/_react.default.createElement(_TwoFactorForm.TwoFactorForm, {
    onSubmit: props.onModalSubmit
  }, /*#__PURE__*/_react.default.createElement(SubmitBtn, {
    type: props.infoTimeout && !props.minOrMaxChanged && props.isEnoughBalance ? 'submit' : 'button',
    onClick: props.minOrMaxChanged || !props.isEnoughBalance ? props.toggleModal : undefined
  })) : /*#__PURE__*/_react.default.createElement(SubmitBtn, {
    type: "button",
    onClick: props.minOrMaxChanged || !props.isEnoughBalance ? props.toggleModal : props.infoTimeout ? props.onModalSubmit : props.getExchangeInfo
  }), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: "".concat(balanceName, " ").concat(t('libCommon:balance').toLowerCase(), " ").concat(t('after'), ":"),
    ticker: props.ticker
    // fiatTicker={props.fiatTicker}
    ,
    amount: props.balanceAfterTransaction
    // fiatTickerAmount={props.fiatBalanceAfterTransaction}
  }), children, /*#__PURE__*/_react.default.createElement(StyledAlert, {
    component: _ui.ExtraSmall
  }, t(props.isFiat ? 'libTransfers:sendFiatAttention' : 'libTransfers:sendAttention'))));
};
exports.ConfirmModal = ConfirmModal;